import InterBoldItalicText from './InterBoldItalicText';

export default InterBoldItalicText;
